function toastMessage(obj, message, type) {
    obj.$buefy.toast.open({
        message: message,
        type: type,
        duration: 3000
    })
    return true
}

export function displaySuccess(obj, message) {
    toastMessage(obj, message, 'is-success')
    return true
}

export function displayError(obj, message) {
    toastMessage(obj, message, 'is-danger')
    return true
}

export default {
    displaySuccess,
    displayError,
}
